import { createAction } from '@reduxjs/toolkit';

import { IAuth, ICredentials, IError } from '../../interfaces';

export const resetForgotPasswordStatus = createAction('auth.reset-forgot-password-status');
export const resetRegisterStatus = createAction('auth.reset-register-status');
export const resetLoginStatus = createAction('auth.reset-login-status');
export const resetCheckEmailInDatabaseStatus = createAction('auth.reset-check-email-in-database-status');
export const resetLogoutStatus = createAction('auth.reset-logout-status');

export const login = createAction<{ credentials: ICredentials }>('auth.login');
export const loginSucceeded = createAction<{ auth: IAuth; credentials: ICredentials }>('auth.login.succeeded');
export const loginFailed = createAction<IError>('auth.login.failed');

export const forgotPassword = createAction<{ email: string }>('auth.forgot-password');
export const forgotPasswordSucceeded = createAction('auth.forgot-password.succeeded');
export const forgotPasswordFailed = createAction<IError>('auth.forgot-password.failed');

export const register = createAction<{ credentials: ICredentials }>('auth.register');
export const registerSucceeded = createAction('auth.register.succeeded');
export const registerFailed = createAction<IError>('auth.register.failed');

export const checkEmailInDatabase = createAction<{ email: string }>('auth.check-email-in-database');
export const checkEmailInDatabaseSucceeded = createAction('auth.check-email-in-database.succeeded');
export const checkEmailInDatabaseFailed = createAction<IError>('auth.check-email-in-database.failed');

export const logout = createAction('auth.logout');
export const logoutSucceeded = createAction('auth.logout.succeeded');
export const logoutFailed = createAction<IError>('auth.logout.failed');
